import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useSelector} from "react-redux";

export default function ({register, errors, control, data}) {
  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');

  return (
    <>
      <ReactSelectInput
        label='Category'
        name='category_id'
        control={control}
        errorMessage={errors?.category_id}
        options={data?.categories}
        inputClassName='col-xxl-3 col-lg-6'
      />

      {isAdmin && (
        <ReactSelectInput
          label='Seller'
          name='shop_id'
          control={control}
          errorMessage={errors?.shop_id}
          options={data?.shops}
          inputClassName='col-xxl-3 col-lg-6 mb-5'
        />
      )}

      <TextInput
        label='Min price'
        name='min_price'
        register={register}
        errorMessage={errors?.min_price}
        parentClasses='col-xxl-3 col-lg-6'
      />

      <TextInput
        label='Max price'
        name='max_price'
        register={register}
        errorMessage={errors?.max_price}
        parentClasses='col-xxl-3 col-lg-6'
      />
     
      <TextInput
        label='Min quantity'
        name='min_quantity'
        register={register}
        errorMessage={errors?.min_quantity}
        parentClasses='col-xxl-3 col-lg-6'
      />

      <TextInput
        label='Max quantity'
        name='max_quantity'
        register={register}
        errorMessage={errors?.max_quantity}
        parentClasses='col-xxl-3 col-lg-6'
      />
    </>
  );
}